export const isDollarEuroNumber = (value) => {
  if (value === undefined || value === null || typeof value !== "string") {
    return false;
  }
  const regexDollar = /\$\d+/g;
  const regexEuro = /\€\d+/g;

  const isDollar = value.match(regexDollar);
  const isEuro = value.match(regexEuro);

  const isDollarEuroNumber = isDollar || isEuro;
  return isDollarEuroNumber;
};
